import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)


import qs from "qs"
export default new Vuex.Store({
  state: {
    isAudioPlay: false,
    isInscenicArea: false,
    isAudioStop: false,
    isScenicSwitch: false, //连续播放开关
    isNscScenicSwitch: false,
    isLocationSuccess: false,
    willClockInArr: [],
    tabsindexArr: [],
    nscScenicChild: {},
    isNscScenicShow: false,
    nscCurrentPlayIndex: -1, //点击的是否为内部的子语音
    isScenicImg: false,
    isNewScenicShow: false,
    isListScenicShow: false,
    isNewScenicIndex: -1

  },
  getters: {},
  mutations: {
    SET_SMALLSCENIC_IMG(state, flag) {
      state.isScenicImg = flag
    },
    SET_AUDIO_PLAYSTATE(state, flag) {
      state.isAudioPlay = flag
    },
    SET_AUDIO_STOPSTATE(state, flag) {
      state.isAudioStop = flag
    },
    SET_AUDIO_TABSDEX(state, arr) {
      state.tabsindexArr = arr
    },
    SET_NewScenicShow(state, flag) {
      state.isNewScenicShow = flag
    },
    SET_NewScenicIndex(state, index) {
      state.isNewScenicIndex = index
    },
    SET_AUDIO_CONTINUOUS(state, flag) {
      if (flag) {
        state.isNscScenicSwitch = false;
      }
      state.isScenicSwitch = flag
    },
    SET_AUDIONSC_CONTINUOUS(state, flag) {
      if (flag) {
        state.isScenicSwitch = false;
      }
      state.isNscScenicSwitch = flag;
    },
    SET_IsInscenicArea(state, flag) {
      state.isInscenicArea = flag
    },
    SET_IsLocationSuccess(state, flag) {
      state.isLocationSuccess = flag
    },
    SET_NscScenicChild(state, obj) {
      state.nscScenicChild = obj
    },
    SET_ListScenicShow(state, flag) {
      state.isListScenicShow = flag
    },
    SET_NscScenicShow(state, flag) {
      state.isNscScenicShow = flag
    },
    SET_NscCurrentPlayIndex(state, index) {
      state.nscCurrentPlayIndex = index
    },
    SET_WillClockInArr(state, arr) {
      state.willClockInArr = arr
    },
    INIT_TabsIndexArr(state) { //初始化所有 索引值
      state.tabsindexArr.forEach((item, idx) => {
        item.currentPlayIndex = -1;
        item.bidakaIndex = -1
      })
    },
    SET_NSCContinuousPlay(state, index) {
      let len = state.nscScenicChild.childAudio.length - 1;
      if (state.nscCurrentPlayIndex >= len) {
        state.nscCurrentPlayIndex = 0
      } else {
        state.nscCurrentPlayIndex++;
      }
    }
  },
  actions: {

  },
  modules: {}
})
